var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 177,
    viewBox: "0 0 189 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2785 6.19434C34.2785 6.19434 33.9286 20.7057 45.256 33.6848C56.5813 46.664 80.4271 47.2964 89.7442 58.1889C89.7442 58.1889 96.0381 16.5524 50.7068 12.8467C50.7068 12.8467 43.4848 8.78712 34.2785 6.19434Z",
    fill: "#42A268"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7425 58.1889C89.7425 58.1889 96.0365 16.5524 50.7051 12.8467C50.7051 12.8467 78.728 26.2694 89.7425 58.1889Z",
    fill: "#368F65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7212 88.8344C46.3908 99.3075 37.1344 154.237 1.00073 119.7C1.00073 119.7 13.9864 121.941 20.3586 105.776C26.7287 89.6101 41.1507 84.1161 54.7212 88.8344Z",
    fill: "#61BB7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5239 110.416C36.6219 126.792 24.4945 142.155 1.00073 119.7C1.00073 119.7 10.9242 126.887 26.1442 124.175C36.3609 122.354 41.9531 115.032 44.5239 110.416Z",
    fill: "#368F65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.797 43.7387C118.797 43.7387 137.994 48.783 152.39 30.1403C152.39 30.1403 176.221 8.2027 182.476 1.00049C182.476 1.00049 178.348 3.70824 153.099 7.72022C127.847 11.732 134.725 28.7535 118.797 43.7387Z",
    fill: "#368F65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.156 38.5509C125.156 38.5509 132.213 33.5612 149.558 35.804C166.904 38.0469 182.119 29.4405 182.475 1.00049C182.475 1.00049 166.23 16.9004 153.172 23.6355C140.115 30.3707 131.513 34.7171 125.156 38.5509Z",
    fill: "#61BB7A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.69 74.9356C119.69 74.9356 116.995 54.3237 143.071 54.9148C169.147 55.5038 181.169 57.4076 187.666 50.0835C187.666 50.0835 187.672 102.463 119.69 74.9356Z",
    fill: "#42A268"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.666 50.0835C187.666 50.0835 187.661 99.8007 124.773 76.8848C129.348 78.0802 136.786 78.8126 146.142 75.4419C162.19 69.6609 183.88 77.4697 187.666 50.0835Z",
    fill: "#368F65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 119.699C1 119.699 13.2728 132.913 39.7027 101.765C66.1326 70.6142 97.0463 82.648 97.0463 135.981M97.0463 135.981C97.0463 135.981 114.983 30.262 34.2759 6.19231M97.0463 135.981C101.769 9.51533 131.035 53.3382 182.474 1M97.0463 135.981C101.784 32.7959 167.197 87.1835 187.666 50.0828",
    stroke: "#61C88A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4597 126.906L70.5374 134.693L79.7416 176.328H90.8319H105.7H116.79L125.994 134.693L112.07 126.906L98.265 127.365L84.4597 126.906Z",
    fill: "#FFBFAE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5368 120.536H125.992C127.686 120.536 129.06 121.909 129.06 123.604V131.626C129.06 133.321 127.686 134.695 125.992 134.695H70.5368C68.842 134.695 67.468 133.321 67.468 131.626V123.604C67.468 121.909 68.842 120.536 70.5368 120.536Z",
    fill: "#FFBFAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2639 122.54H125.994",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73 146L81 141",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90 146L81 141",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105 146L98 141",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90 146L98 141",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105 146L114 141",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122 146L114 141",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75 155L83 150",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90 155L83 150",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105 155L98 150",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90 155L98 150",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105 155L112 150",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120 155L112 150",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77 165L84 160",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91 165L84 160",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104 165L98 160",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91 165L98 160",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M104 165L111 160",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M118 165L111 160",
    stroke: "#DF9E8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.994 135.693C126.547 135.693 126.994 135.246 126.994 134.693C126.994 134.141 126.547 133.693 125.994 133.693V135.693ZM70.5374 134.693V133.693C70.2342 133.693 69.9475 133.831 69.7577 134.067C69.5678 134.304 69.4955 134.613 69.5609 134.909L70.5374 134.693ZM125.994 133.693H70.5374V135.693H125.994V133.693ZM69.5609 134.909L78.7652 176.544L80.7181 176.112L71.5138 134.477L69.5609 134.909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.78837a096742bb897a64f742f2be9abb.svg";
export { ForwardRef as ReactComponent };